import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import '@grandvisionhq/state';
import '../../../../../../../context/actions.js';
import '../../../../../../../context/reducer.js';
import '../../../../../../../types/product.js';
import '../../../../../../../context/ProductContext.js';
import '../../../../../../../context/CmsContext.js';
import '../../../../../../../hooks/useCartDiscountsQuery/types.js';
import '@grandvisionhq/graphql';
import '../../../../../../../operations/queries/get-accessories-by-slug.js';
import '../../../../../../../operations/queries/get-contact-lens-by-slug.js';
import '../../../../../../../operations/queries/get-frames-by-slug.js';
import '../../../../../../../operations/queries/get-solutions-by-slug.js';
import '../../../../../../../operations/queries/get-sunglasses-by-slug.js';
import '../../../../../../../operations/queries/get-ready-reader-by-slug.js';
import '../../../../../../../operations/queries/get-cart-discounts-by-promotion-identifier.js';
import '../../../../../../../operations/queries/get-manufacturer-by-key.js';
import '@grandvisionhq/utils';
import '../../../../../../../hooks/use-product-view-history.js';
import '@grandvisionhq/frk-routing';
import 'classnames';
import '@grandvisionhq/common';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/elements';
import '@grandvisionhq/icons';
import '@grandvisionhq/forms';
import '@grandvisionhq/analytics';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/svc-tealium/utils';
import '@grandvisionhq/inventory';
import '@grandvisionhq/lib-utils-html';
import '../../../../../../VTO/context/VtoProvider.js';
import 'usehooks-ts';
import 'use-onclickoutside';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/lib-visuals';
import '../../../../../../../slots/context.js';
import '@grandvisionhq/content';
import { useCLEcommContext } from '../../../../context/CLEcommContext.js';
import { useFetchCLForActiveVariant } from '../../hooks/use-fetch-cl-for-active-variant.js';
import { CLPrescriptionColumn } from './CLPrescriptionColumn.js';

const CLPrescriptionColumnContainer = (props)=>{
    const { eyeSideId  } = props;
    const { actions , state  } = useCLEcommContext();
    const { columnCheckboxes  } = state.configurator;
    const { isEnabled: isEnabled1  } = state.configurator[eyeSideId];
    // Fetch the CL variant for the active variant and selected prescription
    useFetchCLForActiveVariant({
        eyeSide: eyeSideId
    });
    const handleAttributeChange = React.useCallback((attribute, value, eyeSide)=>actions.updatePrescriptionAttribute(eyeSide, attribute, value)
    , []);
    const handleCheckboxChange = React.useCallback((isEnabled, eyeSide)=>actions.updateColumnCheckbox(eyeSide, isEnabled)
    , []);
    return /*#__PURE__*/ React.createElement(CLPrescriptionColumn, swcHelpers.extends({}, props, {
        isEnabled: isEnabled1,
        showCheckboxError: columnCheckboxes.showError,
        onAttributeChange: handleAttributeChange,
        onCheckboxChange: handleCheckboxChange
    }));
};

export { CLPrescriptionColumnContainer };
//# sourceMappingURL=CLPrescriptionColumnContainer.js.map
